{
  "customer-request-online-booking-dialog": {
    "buttons": {
      "submit": "PŘEDLOŽIT"
    },
    "text": {
      "title": "Online žádost o rezervaci",
      "email": "Váš e-mail",
      "hint": "Salon zatím nenabízí online rezervaci termínů. Zanechte nám svůj e-mail a my vás upozorníme, až bude v budoucnu v salonu povolena online rezervace schůzek",
      "request-sent-success": "Váš požadavek byl úspěšně odeslán!"
    }
  }
}
